// custom-cart.js
const storefrontToken = "274f505ba63be8ac1381b9f071e4facf";
const cartId = localStorage.getItem("shopify_cart_id");
const container = document.getElementById("cart-container");

if (!cartId) {
  container.innerHTML = "<p>Sepet bulunamadı.</p>";
} else {
  fetchCart(cartId);
}

async function fetchCart(cartId) {
  const query = `
    query {
      cart(id: "${cartId}") {
        id
        checkoutUrl
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              attributes { key value }
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  price { amount currencyCode }
                  product {
                    title
                    featuredImage { url }
                    options { name values }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const res = await fetch("/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontToken,
    },
    body: JSON.stringify({ query }),
  });

  const data = await res.json();
  renderCart(data.data.cart);
}

function renderCart(cart) {
  const items = cart.lines.edges;
  const checkoutUrl = cart.checkoutUrl;
  const tbody = document.getElementById("cart-body");
  const subtotalEl = document.getElementById("cart-subtotal");
  const progressBar = document.querySelector(".progress-bar");
  const freeShippingText = document.querySelector(".free-shipping-goal__label");
  const summaryEl = document.querySelector(".cart__footer");

  if (!items.length) {
    container.innerHTML = `
      <div class="cart__empty text-center flex flex-col gap-10">
        <h2 class="h1">Sepetiniz boş</h2>
        <div class="rte text-subtext">Sepetinize ürün ekleyerek alışverişe başlayabilirsiniz.</div>
        <a class="btn btn--primary self-center" href="/collections/all">
          <span class="btn__text">Alışverişe Devam Et</span>
        </a>
      </div>
    `;
    if (summaryEl) summaryEl.style.display = "none";
    return;
  }

  if (summaryEl) summaryEl.style.display = "";

  tbody.innerHTML = items
    .map(({ node }) => {
      const variant = node.merchandise;
      const product = variant.product;
      const price = parseFloat(variant.price.amount);
      const total = (price * node.quantity).toFixed(2);
      const attrs = node.attributes || [];
      const attrsHtml = attrs
        .map((attr) => {
          const fallback =
            (product.options || []).find((o) => o.name === attr.key)
              ?.values[0] || "";
          const value = attr.value || fallback;
          return `<div class="cart-item__attribute">${attr.key}: ${value}</div>`;
        })
        .join("");

      return `
      <tr class="cart-item" data-line-id="${node.id}">
        <td>
          <div class="flex gap-4 items-center">
            <img style="border-radius:5px;" src="${
              product.featuredImage?.url
            }" width="100" />
            <div>
              <p class="cart-item__title">${product.title}</p>
              ${attrsHtml}
              <div style="font-size:15px;font-weight:600; margin-top:12px;">
                ${price.toFixed(2)} ${variant.price.currencyCode}
              </div>
            </div>
          </div>
        </td>
        <td style="padding:0 20px; vertical-align: middle;">
          <div class="quantity-control" data-line-id="${
            node.id
          }" style="display:flex; align-items:center; gap:8px;">
            <button type="button" class="qty-btn qty-decrease" aria-label="Adeti azalt" style="padding:4px 8px; font-weight:600;">−</button>
            <span class="qty-value" style="min-width:24px; text-align:center; display:inline-block;">${
              node.quantity
            }</span>
            <button type="button" class="qty-btn qty-increase" aria-label="Adeti artır" style="padding:4px 8px; font-weight:600;">+</button>
          </div>
        </td>
        <td>${total} ${variant.price.currencyCode}</td>
        <td>
          <button type="button" class="remove-btn btn-remove" data-id="${
            node.id
          }" aria-label="Ürünü Kaldır">
            🗑
          </button>
        </td>
        <hr style="margin-top:15px !important;" class="cart__divider">
      </tr>
    `;
    })
    .join("");

  const subtotal = items.reduce(
    (sum, { node }) =>
      sum + parseFloat(node.merchandise.price.amount) * node.quantity,
    0
  );
  subtotalEl.textContent = subtotal.toFixed(2) + " TL";

  const kargoLimiti = 2000;
  const percent = Math.min(100, (subtotal / kargoLimiti) * 100);
  progressBar.style.setProperty("--percent", percent + "%");
  progressBar.value = subtotal;

  if (subtotal >= kargoLimiti) {
    freeShippingText.textContent = "Kargo ücretsiz!";
  } else {
    const kalan = (kargoLimiti - subtotal).toFixed(2);
    freeShippingText.innerHTML = `Kargo ücretsiz için <strong>${kalan} TL</strong> kaldı`;
  }

  const checkoutBtn = document.getElementById("checkout-button");
  if (checkoutBtn && checkoutUrl) {
    checkoutBtn.setAttribute("href", checkoutUrl);
    checkoutBtn.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = checkoutUrl;
    });
  }

  setupEventListeners();
}

function setupEventListeners() {
  // Kaldırma butonları
  document.querySelectorAll(".remove-btn").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      await removeLineItem(e.currentTarget.dataset.id);
    });
  });

  // Arttırma
  document.querySelectorAll(".qty-increase").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      const control = e.currentTarget.closest(".quantity-control");
      const lineId = control.dataset.lineId;
      const currentQty = parseInt(
        control.querySelector(".qty-value").textContent,
        10
      );
      await updateLineItemQuantity(lineId, currentQty + 1);
    });
  });

  // Azaltma (1 ise sil; değilse güncelle)
  document.querySelectorAll(".qty-decrease").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      const control = e.currentTarget.closest(".quantity-control");
      const lineId = control.dataset.lineId;
      const currentQty = parseInt(
        control.querySelector(".qty-value").textContent,
        10
      );
      if (currentQty > 1) {
        await updateLineItemQuantity(lineId, currentQty - 1);
      } else {
        await removeLineItem(lineId);
      }
    });
  });
}

async function removeLineItem(lineId) {
  const row = document.querySelector(`tr[data-line-id="${lineId}"]`);
  const qtyText = row?.querySelector(".qty-value")?.textContent || "1";
  const removedQty = parseInt(qtyText, 10);

  const mutation = `
    mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart { id }
        userErrors { field message }
      }
    }
  `;

  await fetch("/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontToken,
    },
    body: JSON.stringify({
      query: mutation,
      variables: { cartId, lineIds: [lineId] },
    }),
  });

  document.querySelectorAll(".cart-count").forEach((el) => {
    const current = parseInt(el.textContent) || 0;
    const updated = Math.max(0, current - removedQty);
    el.textContent = updated > 99 ? "99+" : updated;
  });

  fetchCart(cartId);
}

async function updateLineItemQuantity(lineId, quantity) {
  const mutation = `
    mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart { id }
        userErrors { field message }
      }
    }
  `;
  await fetch("/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontToken,
    },
    body: JSON.stringify({
      query: mutation,
      variables: { cartId, lines: [{ id: lineId, quantity }] },
    }),
  });

  fetchCart(cartId);
  updateCustomCartCount(cartId);
}

function updateCustomCartCount(cartId) {
  if (!cartId) return;
  const query = `
    query {
      cart(id: "${cartId}") {
        id
        lines(first: 100) {
          edges { node { quantity } }
        }
      }
    }
  `;
  fetch("/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontToken,
    },
    body: JSON.stringify({ query }),
  })
    .then((res) => res.json())
    .then((data) => {
      const items = data.data.cart?.lines?.edges || [];
      const totalQty = items.reduce((sum, edge) => sum + edge.node.quantity, 0);
      document.querySelectorAll(".cart-count").forEach((el) => {
        el.removeAttribute("hidden");
        el.textContent = totalQty > 99 ? "99+" : totalQty;
      });
    })
    .catch((err) => console.error("cart-count güncelleme hatası:", err));
}